import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaIconComponent } from 'ra-ui';
import { RaEditTooltipDirective } from '../../directives/ra-edit-tooltip/ra-edit-tooltip.directive';
import { EditMode, EditModeService } from '../../services/edit-mode.service';

/**
 * Rail de modos do editor: exatamente dois ícones, lápis (editar manualmente) e balão
 * (editar com IA). O modo ativo fica com fundo `--primaryLight`. Seções e histórico
 * vivem dentro de cada modo, nunca aqui (docs/EDITOR-CHAT-IA.md, seção 2).
 */
@Component({
    selector: 'edit-mode-rail',
    templateUrl: 'edit-mode-rail.component.html',
    styleUrl: 'edit-mode-rail.component.scss',
    imports: [RaIconComponent, RaEditTooltipDirective, TranslatePipe],
})
export class EditModeRailComponent {
    public modeService = inject(EditModeService);

    /** O destino da troca em andamento já aparece ativo: o clique tem resposta na hora. */
    public activeMode = computed<EditMode>(
        () => this.modeService.switchingTo() ?? this.modeService.mode()
    );

    public aiTooltipKey = computed(() => {
        switch (this.modeService.aiUnavailableReason()) {
            case 'type':
                return 'document.edit.modeRail.aiUnavailableType';
            case 'template':
                return 'document.edit.modeRail.aiUnavailableTemplate';
            default:
                return 'document.edit.modeRail.ai';
        }
    });

    public select(mode: EditMode): void {
        if (mode === 'ai' && !this.modeService.aiAvailable()) return;
        void this.modeService.switchTo(mode);
    }
}
